module.exports = __webpack_public_path__ + "img/mailchimp.113a9b99.svg";